export const locale = {
    lang: 'fr',
    data: {
        'NOTIF': {
            'TITLE': 'Envoyer un message',
            'DESCRIPTION': 'Description',
            'NAME': 'Libellé',
            'USER': 'Utilisateur',
            'GROUPE': 'Groupe',
            'AFFECTER_GROUPE': 'Affecter groupe',
            'AFFECTER_USER': 'Affecter utilisateur',
            'REQUIRED_USER':'Il faut choisir au minimum un destinataire',
            'REQUIRED': 'Champ obligatoire',
        }
    }
};